var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useEffect, useRef } from 'react';
import { DatePicker as MuiDatePicker, } from '@material-ui/pickers';
import { withStyles } from '@material-ui/core';
import EventIcon from '@material-ui/icons/Event';
import ClearIcon from '@material-ui/icons/Clear';
import styled from 'styled-components';
import { dVariant } from 'component/config';
import { format, isValid } from 'date-fns';
import DateEnum from './enum';
// onchange example----------------------------------------------------
// export const DatePickerChange = UpdateData => (name, dateFormat: (DateEnum | string[]) = DateEnum.daFormat) => date => {
//     if (isArray(name) && isArray(dateFormat) && name.length === dateFormat.length) {
//         const updateObj = {};
//         name.forEach((obj, idx) => updateObj[name[idx]] = DateFormatTrans(date, dateFormat[idx] as DateEnum))
//         UpdateData(updateObj)
//     }
//     else {
//         UpdateData({ [name]: DateFormatTrans(date, dateFormat) });
//     }
//     return null
// }
// const----------------------------------------------------
export var EmptyDateMsg = '請填寫這個欄位。';
export var dateErrStr = '起始日期不得大於結束日期。';
// style----------------------------------------------------
var StyleSpan = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  color: rgba(0, 0, 0, 0.54);\n  border-radius: 50%;\n  padding: 0.7em;\n  position: absolute;\n  top: 0;\n  right: 5px;\n  transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  :hover {\n    background-color: rgba(0, 0, 0, 0.04);\n    color: rgba(0, 0, 0, 0.8);\n  }\n"], ["\n  display: flex;\n  color: rgba(0, 0, 0, 0.54);\n  border-radius: 50%;\n  padding: 0.7em;\n  position: absolute;\n  top: 0;\n  right: 5px;\n  transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  :hover {\n    background-color: rgba(0, 0, 0, 0.04);\n    color: rgba(0, 0, 0, 0.8);\n  }\n"])));
// html required 無效，因為 input readonly
var StyleDatePicker = withStyles({
    root: {
        '& .MuiInputBase-formControl': {
            padding: 0,
            '& input': {
                padding: '0.675em 2.1em 0.675em 0.75em',
                fontSize: '1.15em',
            },
            '& input:disabled': {
                padding: '0.675em 0.75em',
            },
        },
    },
})(MuiDatePicker);
var DatePicker = function (props) {
    var name = props.name, value = props.value, onChange = props.onChange, onClose = props.onClose, error = props.error, helperText = props.helperText, _a = props.verifiers, verifiers = _a === void 0 ? [] : _a, _b = props.verifyBeforeChange, verifyBeforeChange = _b === void 0 ? false : _b, required = props.required, className = props.className, disabled = props.disabled, _c = props.format, dateFormat = _c === void 0 ? DateEnum.daFormatP : _c, minDate = props.minDate, maxDate = props.maxDate, other = __rest(props, ["name", "value", "onChange", "onClose", "error", "helperText", "verifiers", "verifyBeforeChange", "required", "className", "disabled", "format", "minDate", "maxDate"]);
    var _d = useState(false), open = _d[0], setOpen = _d[1];
    var _e = useState(''), message = _e[0], setMessage = _e[1];
    var _f = useState(verifyBeforeChange), firstVerify = _f[0], setFirstVerify = _f[1];
    var dateRef = useRef(value);
    useEffect(function () {
        dateRef.current = value;
    }, [value]);
    if (required) {
        verifiers.push({ func: function (d) { return !d; }, text: EmptyDateMsg });
    }
    useEffect(function () {
        setFirstVerify(verifyBeforeChange);
    }, [verifyBeforeChange]);
    useEffect(function () {
        // 始設畫面預設不 verify , 除非 verifyBeforeChange = true
        if (!firstVerify)
            return;
        // 驗使用者設定之 verifier, 空值也要驗(不能驗 HTML validation)
        // input 為 readonly or hidden 時，不會觸發
        if (verifiers.length > 0) {
            var veriObj = verifiers.find(function (obj) { return obj.func(value); });
            if (veriObj) {
                setMessage(veriObj.text);
                return;
            }
        }
        // 先前檢驗都 pass
        setMessage('');
    }, [value, firstVerify]);
    var LocalPicker = (React.createElement(StyleDatePicker, __assign({ name: name, value: value, style: { width: '100%' }, autoOk: true, variant: "inline", inputVariant: dVariant, error: error || message.length > 0, helperText: message || helperText, open: open, onChange: function (d) {
            dateRef.current = d;
            setFirstVerify(true);
            if (onChange) {
                onChange(d, name);
            }
        }, onOpen: function () { return setOpen(true); }, onClose: function () {
            setOpen(false);
            if (onClose) {
                onClose(dateRef.current);
            }
        }, format: dateFormat, minDate: minDate, maxDate: maxDate, invalidDateMessage: "\u7121\u6548\u7684\u65E5\u671F\u683C\u5F0F", minDateMessage: "\u65E5\u671F\u4E0D\u5F97\u5C0F\u65BC" + (isValid(minDate)
            ? " " + format(minDate, dateFormat)
            : '最小日期'), maxDateMessage: "\u65E5\u671F\u4E0D\u5F97\u5927\u65BC" + (isValid(maxDate)
            ? " " + format(maxDate, dateFormat)
            : '最大日期') }, other)));
    var chooseIcon = !value ? (React.createElement("label", { style: { position: 'relative', width: '100%', display: 'flex' } },
        LocalPicker,
        React.createElement(StyleSpan, null,
            React.createElement(EventIcon, null)))) : (React.createElement("div", { style: { position: 'relative', width: '100%', display: 'flex' } },
        LocalPicker,
        React.createElement(StyleSpan, { onClick: onChange ? function () { return onChange(null); } : undefined },
            React.createElement(ClearIcon, null))));
    return (React.createElement("div", { className: className, style: { width: '100%' } }, disabled ? (React.createElement(StyleDatePicker, __assign({ name: name, value: value, disabled: disabled, style: { width: '100%' }, autoOk: true, variant: "inline", inputVariant: dVariant, onChange: function () { return undefined; }, format: dateFormat, minDate: minDate, maxDate: maxDate, invalidDateMessage: "\u7121\u6548\u7684\u65E5\u671F\u683C\u5F0F", minDateMessage: "\u65E5\u671F\u4E0D\u5F97\u5C0F\u65BC" + (isValid(minDate)
            ? " " + format(minDate, dateFormat)
            : '最小日期'), maxDateMessage: "\u65E5\u671F\u4E0D\u5F97\u5927\u65BC" + (isValid(maxDate)
            ? " " + format(maxDate, dateFormat)
            : '最大日期') }, other))) : (chooseIcon)));
};
export default DatePicker;
var templateObject_1;
